import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initTelegramWebApp } from "./telegram/init.ts";
import { initI18n } from "@tarifdata/i18n";
import { useSettingsStore } from "./stores/settingsStore.ts";

const TELEGRAM_BOT_URL = "https://t.me/tarifdata_bot";

const initApp = async () => {
  const tg = window.Telegram?.WebApp;
  if (!tg || !tg.initData) {
    window.location.replace(TELEGRAM_BOT_URL);
    return;
  }

  const sdkInitialized = initTelegramWebApp();
  if (!sdkInitialized) {
    console.warn("Telegram SDK initialization failed, but continuing anyway");
  }

  const lang = useSettingsStore.getState().language;
  await initI18n(lang);

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

if (typeof window !== "undefined" && window.Telegram?.WebApp) {
  initApp().catch((err) => console.error("App initialization failed:", err));
} else {
  window.addEventListener("load", () =>
    initApp().catch((err) => console.error("App initialization failed:", err))
  );
}
